import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  location: 'Buenos Aires',
  time: 'hace 3 min'
}, {
  name: 'Carolina S.',
  location: 'Córdoba',
  time: 'hace 5 min'
}, {
  name: 'Luciana R.',
  location: 'Rosario',
  time: 'hace 8 min'
}, {
  name: 'Valentina G.',
  location: 'Mendoza',
  time: 'hace 12 min'
}, {
  name: 'Florencia M.',
  location: 'La Plata',
  time: 'hace 15 min'
}, {
  name: 'Agustina P.',
  location: 'Tucumán',
  time: 'hace 18 min'
}, {
  name: 'Camila D.',
  location: 'Mar del Plata',
  time: 'hace 22 min'
}, {
  name: 'Julieta B.',
  location: 'Salta',
  time: 'hace 25 min'
}, {
  name: 'Rocío T.',
  location: 'Santa Fe',
  time: 'hace 30 min'
}, {
  name: 'Daniela V.',
  location: 'Neuquén',
  time: 'hace 35 min'
}, {
  name: 'Paula H.',
  location: 'San Juan',
  time: 'hace 40 min'
}, {
  name: 'Milagros F.',
  location: 'Bahía Blanca',
  time: 'hace 45 min'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showDelay = setTimeout(() => {
      setVisible(true);
    }, 4000);
    return () => clearTimeout(showDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex, dismissed]);
  if (dismissed) return null;
  const purchase = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50" data-id="element-244">
      <AnimatePresence data-id="element-245">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-[#1A1A1A] border border-[#D4A843]/30 rounded-xl shadow-2xl shadow-black/40 px-4 py-3 max-w-xs" data-id="element-246">
            <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-300 transition-colors" aria-label="Cerrar notificación" data-id="element-247">
              <XIcon className="w-3.5 h-3.5" data-id="element-248" />
            </button>

            <div className="flex items-start gap-3 pr-4" data-id="element-249">
              <div className="flex-shrink-0 mt-0.5" data-id="element-250">
                <div className="w-9 h-9 rounded-full bg-[#D4A843]/20 flex items-center justify-center" data-id="element-251">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4A843]" data-id="element-252" />
                </div>
              </div>
              <div className="min-w-0" data-id="element-253">
                <p className="text-sm text-white font-semibold font-['Open_Sans',_sans-serif] leading-tight" data-id="element-254">
                  {purchase.name}
                  <span className="text-gray-400 font-normal" data-id="element-255"> de </span>
                  {purchase.location}
                </p>
                <p className="text-xs text-[#D4A843] mt-0.5 font-['Open_Sans',_sans-serif]" data-id="element-256">
                  adquirió el Megapack 🧠
                </p>
                <p className="text-[10px] text-gray-500 mt-1" data-id="element-257">
                  {purchase.time}
                </p>
              </div>
            </div>

            <div className="mt-2 flex items-center gap-1.5" data-id="element-258">
              <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-259" />
              <span className="text-[10px] text-gray-500" data-id="element-260">
                +2.400 profesionales ya lo tienen
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}